import { Button } from '@mui/material'
import React, { useState } from 'react'

import HaltConfirmation from 'components/attacks/HaltConfirmation'
import ResultsForm from 'components/scenarios/detail/ResultsForm'

export const HaltButton: React.FC<{
  fetchAttack(): void
  trackingOptions: Record<string, any>
  title?: string
  trackedEvent?: string
  type?: string
  showHaltReason?: boolean
  onConfirmRequest(): void
  isHalting: boolean
  runInfo?: Record<string, any>
}> = ({
  fetchAttack,
  title = 'Halt attack',
  trackingOptions,
  trackedEvent = 'SingleAttackHalted',
  type = 'attack',
  showHaltReason = true,
  onConfirmRequest,
  isHalting = false,
  runInfo = {}
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const showResultsForm = Boolean(runInfo?.scenario_id)

  // TODO migrate HaltConfirmation to MUI
  return (
    <div
      css={{ position: 'relative', justifySelf: 'center' }}
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <Button
        color="error"
        data-track-action="active-attack-notification-halt-clicked"
        data-track-category="active-attack"
        data-track-on="click"
        disabled={isHalting}
        size="small"
        variant="contained"
        onClick={(e) => {
          e.preventDefault()
          setIsModalOpen(true)
        }}
      >
        {isHalting ? ' Halting' : 'Halt'}
      </Button>
      <HaltConfirmation
        doFetch={fetchAttack}
        hideFooter={showResultsForm}
        message={
          showResultsForm ? (
            <ResultsForm
              isConfirmationModal
              doFetch={fetchAttack}
              footerOptions={{
                confirmText: 'Confirm'
              }}
              hideSave={true}
              runInfo={runInfo}
              onCancel={() => setIsModalOpen(false)}
              onConfirm={onConfirmRequest}
            />
          ) : null
        }
        open={isModalOpen}
        showConfirmationContent={!showResultsForm}
        showHaltReason={showHaltReason}
        title={title}
        trackedEvent={trackedEvent}
        trackingOptions={trackingOptions}
        type={type}
        onCancel={() => setIsModalOpen(false)}
        onConfirmRequest={onConfirmRequest}
      />
    </div>
  )
}
